import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type RelationshipTypeContext = 'hcp' | 'hcoParent' | 'hcoChild';

const useRelationshipTypeLabels = () => {
	const { t } = useTranslation();

	return useMemo<Record<string, Record<RelationshipTypeContext, string>>>(
		() => ({
			RLTD: { hcp: t('Related to'), hcoParent: '', hcoChild: '' },
			WRKS: { hcp: t('Works at'), hcoParent: '', hcoChild: '' },
			LEDS: { hcp: t('Leader'), hcoParent: '', hcoChild: '' },
			OWNSP: { hcp: t('Owner'), hcoParent: '', hcoChild: '' },
			UNKD: {
				hcp: t('General Affiliation'),
				hcoParent: '',
				hcoChild: ''
			},
			PRTN: {
				hcp: '',
				hcoParent: t('Partner'),
				hcoChild: t('Partner')
			},
			OWNSO: { hcp: '', hcoParent: t('Owner'), hcoChild: t('Subsidiary') }
		}),
		[t]
	);
};

export const useRelationshipTypeLabel = (context: RelationshipTypeContext) => {
	const labels = useRelationshipTypeLabels();

	return useCallback(
		(id?: string | null) => (id ? (labels[id]?.[context] ?? '') : ''),
		[context, labels]
	);
};

export const useRelationshipTypeCodesForContext = (
	context: RelationshipTypeContext
) => {
	const labels = useRelationshipTypeLabels();

	return useMemo(
		() => Object.keys(labels).filter(id => !!labels[id][context]),
		[labels, context]
	);
};
